import React, { Fragment, useEffect, useState } from "react";
import Swal from "sweetalert2";
import M from "materialize-css";

import SideNav from "../../Components/SideNav";
import FormularioAgregar from "../../Components/FormularioAgregar";
import FormularioEditar from "../../Components/FormularioEditar";
import Loader from "../../Components/Loader";
import View from "./View";

import { useAuth } from "../../Context/Context";

import EtiquetasHelper from "../../Helpers/Etiquetas";
import CursosHelper from "../../Helpers/Cursos";
import ProfesoresCursosHelpers from "../../Helpers/ProfesoresCursos";
import useStorage from "../../Hooks/useStorage";

import icon1 from "../../Images/administrador/iconos/1.png";
import icon63 from "../../Images/Icon/63.png";

const General = () => {
  const { editar, caracteres, recargar } = useAuth();

  const [flag, setFlag] = useState(false);
  const [flagFechas, setFlagFechas] = useState(true);
  const [curso, setCurso] = useState({
    archivado: false,
    gratis: false,
    oferta_relampago: false,
    carrusel_imagenes: [],
  });
  const [instance, setInstance] = useState({});
  const [dataPago, setDataPago] = useState({});
  const [pickerInfo, setPickerInfo] = useState("");

  const [fechas, setFechas] = useState([]);
  const [fechasInicio, setFechasInicio] = useState([]);
  const [fechasFin, setFechasFin] = useState([]);

  const [cursos, setCursos] = useState([]);
  const [etiquetas, setEtiquets] = useState([]);
  const [profesoresCursos, setProfesoresCursos] = useState([]);

  const [files, setFiles] = useState({});
  const [filesCarrusel, setFilesCarrusel] = useState([]);

  // datos de oferta relampago masiva
  const [pickerOfertaFechaInicio, setPickerOfertaFechaInicio] = useState("");
  const [pickerOfertaFechaFin, setPickerOfertaFechaFin] = useState("");
  const [descuento, setDescuento] = useState("");
  const [cursosSeleccionados, setCursosSeleccionados] = useState([]);

  // uso de hooks para agregar imagen a google storage
  const [consulta, setConsulta] = useState("");
  let [response] = useStorage(consulta);

  useEffect(() => {
    let fecha = document.querySelectorAll(".datepicker");

    M.Datepicker.init(fecha[0], {
      onSelect: (data) => {
        // Crear un objeto Date con la fecha de entrada
        const fecha = new Date(data);

        let fechaFin = new Date(
          fecha.getFullYear(),
          fecha.getMonth(),
          fecha.getDate(),
          17,
          59,
          0
        );

        setPickerOfertaFechaInicio(fechaFin);
      },
      // defaultDate: new Date();
    });
    M.Datepicker.init(fecha[1], {
      onSelect: (data) => {
        // Crear un objeto Date con la fecha de entrada
        const fecha = new Date(data);

        let fechaFin = new Date(
          fecha.getFullYear(),
          fecha.getMonth(),
          fecha.getDate(),
          17,
          59,
          0
        );

        setPickerOfertaFechaFin(fechaFin);
      },
    });

    if (!response) {
      if (editar || pickerInfo) {
        setCurso({
          ...curso,
          ...editar,
          ...pickerInfo,
        });
      }

      if (!flag) {
        obtenerCursos();
      }
    } else {
      if (response.success) {
        agregar(response.data);
      } else {
        // error
      }
    }
  }, [editar, pickerInfo, response]);

  const obtenerCursos = async () => {
    let res = await CursosHelper.obtenerCursosDatosOferta();
    if (res.success) {
      res.data.sort((a, b) => {
        const nombreA = a.nombre.toUpperCase(); // Convertir a mayúsculas para que la ordenación sea insensible a mayúsculas/minúsculas
        const nombreB = b.nombre.toUpperCase();

        if (nombreA < nombreB) {
          return -1;
        }
        if (nombreA > nombreB) {
          return 1;
        }
        return 0; // Los nombres son iguales
      });

      setCursos(res.data);

      obtenerEtiquetas();
    } else {
      Swal.fire(
        "Error!",
        "No se lograron obtener los cursos, codigo: " + res.code,
        "error"
      );
    }
  };

  const obtenerEtiquetas = async () => {
    let res = await EtiquetasHelper.obtenerEtiquetas();
    if (res.success) {
      setEtiquets(res.data);

      obtenerProfesoresCursos();
    } else {
      Swal.fire(
        "Error!",
        "No se lograron obtener las etiquetas, codigo: " + res.code,
        "error"
      );
    }
  };

  const obtenerProfesoresCursos = async () => {
    let res = await ProfesoresCursosHelpers.obtenerProfesores();
    if (res.success) {
      setProfesoresCursos(res.data);
      setFlag(true);

      setTimeout(() => {
        let select = document.querySelectorAll("select");
        let instance = M.FormSelect.init(select);
        setInstance(instance);
      }, 500);
    } else {
      Swal.fire(
        "Error!",
        "No se lograron obtener los profesores, codigo: " + res.code,
        "error"
      );
    }
  };

  const leerDato = (e) => {
    setCurso({
      ...curso,
      [e.target.name]: e.target.value,
    });

    if (e.target.name === "forma_pago") setDataPago({});
  };

  const leerOpciones = (e) => {
    e.preventDefault();
    let value;

    if (e.target.name === "area") {
      value = instance[0].getSelectedValues();
    } else if (e.target.name === "modalidad") {
      value = instance[1].getSelectedValues();
    } else if (e.target.name === "formato") {
      value = instance[2].getSelectedValues();
    } else if (e.target.name === "dias") {
      value = instance[3].getSelectedValues();
    } else if (e.target.name === "etiquetas") {
      value = instance[6].getSelectedValues();
    } else {
      value = instance[6].getSelectedValues();
    }

    setCurso({
      ...curso,
      [e.target.name]: value,
    });
  };

  const leerFecha = (e, index) => {
    e.preventDefault();
    let copiaFechas = [...fechas];

    copiaFechas[index][e.target.name] = e.target.value;

    setFechas(copiaFechas);
  };

  const agregarFecha = (e) => {
    e.preventDefault();
    let fechaLengthDoble = [...fechas].length * 2;
    let fechaLength = fechas.length;

    if (fechaLength > 0) {
      let fechasString = JSON.stringify(fechas[fechaLength - 1]);

      if (
        fechasString.includes("vacio") ||
        fechasInicio.length < fechaLength ||
        fechasFin.length < fechaLength
      ) {
        Swal.fire("Error!", "Faltan datos por llenar", "error");
        return false;
      }
    }

    setFechas([
      ...fechas,
      {
        dias: "vacio",
        horario: "vacio",
        sesiones: "vacio",
        duracion: "vacio",
        tutor: "vacio",
      },
    ]);

    setTimeout(() => {
      let select = document.querySelectorAll("select");
      M.FormSelect.init(select);

      let elems = document.querySelectorAll(".datepicker");
      M.Datepicker.init(elems[fechaLengthDoble], {
        onSelect: (data) => {
          let copiaFechasInicio = [
            ...fechasInicio,
            {
              fecha_inicio: "vacio",
            },
          ];
          copiaFechasInicio[copiaFechasInicio.length - 1]["fecha_inicio"] =
            data;
          setFechasInicio(copiaFechasInicio);
        },
      });
      M.Datepicker.init(elems[fechaLengthDoble + 1], {
        onSelect: (data) => {
          let copiaFechasFin = [
            ...fechasFin,
            {
              fecha_fin: "vacio",
            },
          ];
          copiaFechasFin[copiaFechasFin.length - 1]["fecha_fin"] = data;
          setFechasFin(copiaFechasFin);
        },
      });
    }, 500);
  };

  const eliminarFecha = (e, index) => {
    e.preventDefault();
    Swal.fire({
      icon: "question",
      title: "¿Esta seguro que desea eliminar la fechaa?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Si",
      denyButtonText: `No`,
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setFlagFechas(false);
        let copiaFechas = [...fechas];

        copiaFechas.splice(index, 1);

        setFechas(copiaFechas);

        setTimeout(() => {
          Swal.fire(
            "Eliminación exitosa",
            "La fecha se elimino correctamente",
            "succes"
          );
          setFlagFechas(true);
        }, 500);
      } else if (result.isDenied) {
        Swal.fire("Eliminación cancelada", "La fecha quedo intacta", "succes");
      }
    });
  };

  const leerPago = (e) => {
    setDataPago({
      ...dataPago,
      [e.target.name]: e.target.value,
    });
  };

  const actualizarFoto = (e) => {
    setFiles({
      ...files,
      [e.target.name]: e.target.files[0],
    });

    let fileReader = new FileReader();
    fileReader.addEventListener("load", (evt) => {
      setCurso({
        ...curso,
        [e.target.name]: fileReader.result,
      });
    });
    fileReader.readAsDataURL(e.target.files[0]);
  };

  const actualizarCarrusel = (e) => {
    if (e.target.files.length === 6) {
      let imagenes = [];
      setFilesCarrusel(e.target.files);

      for (let index = 0; index < 6; index++) {
        const imagen = e.target.files[index];
        let fileReader = new FileReader();
        fileReader.addEventListener("load", (evt) => {
          imagenes.push(fileReader.result);

          if (index === 5) {
            setCurso({
              ...curso,
              [e.target.name]: imagenes,
            });
          }
        });
        fileReader.readAsDataURL(imagen);
      }
    } else {
      e.target.value = "";
      Swal.fire("Error!", "Debes seleccionar 6 imagenes", "error");
    }
  };

  // subir informacion final
  const agregar = async (data) => {
    let copiaFechas = [...fechas];

    fechas.map((fecha, index) => {
      copiaFechas[index]["fecha_inicio"] = fechasInicio[index].fecha_inicio;
      copiaFechas[index]["fecha_fin"] = fechasFin[index].fecha_fin;
    });

    let body = {
      ...curso,
      ...editar,
      ...data,
      fechas: copiaFechas,
      data_pago: dataPago,
    };

    await CursosHelper.agregarCurso(body);
    recargar();
  };

  const leerYoutube = (e) => {
    let value = e.target.value.split("=");

    setCurso({
      ...curso,
      [e.target.name]: "https://www.youtube.com/embed/" + value[1],
    });
  };

  // subir archivos a storage
  const subirArchivo = (e) => {
    e.preventDefault();

    let cursoData = {
      ...curso,
      ...editar,
      fechas: fechas,
      data_pago: dataPago,
      fechasInicio,
      fechasFin,
    };

    // NOTA: borrar
    let copiaFechas = [...fechas];

    fechas.map((fecha, index) => {
      copiaFechas[index]["fecha_inicio"] = fechasInicio[index].fecha_inicio;
      copiaFechas[index]["fecha_fin"] = fechasFin[index].fecha_fin;
    });

    let body = {
      ...curso,
      ...editar,
      // ...data,
      fechas: copiaFechas,
      data_pago: dataPago,
    };

    if (
      cursoData.contenido === undefined ||
      cursoData.descripcion_externa === undefined ||
      cursoData.descripcion_interna === undefined ||
      cursoData.nivel === undefined ||
      cursoData.fechas.length === 0 ||
      cursoData.etiquetas === undefined ||
      cursoData.data_pago.costo_total === undefined
    ) {
      Swal.fire("Error!", "Faltan datos por llenar", "error");
      return false;
    }

    setConsulta({
      consulta: "agregarRecursivoCursos",
      name: cursoData.nombre,
      folder: "cursos/",
      filesJSON: { files, filesCarrusel },
      url: "/cursos-diplomados",
    });
  };

  // Funciones de oferta relampago masiva
  const actualizarOfertaRelampago = async (e) => {
    e.preventDefault();

    let cursosFiltro = cursos.filter((curso) =>
      cursosSeleccionados.includes(curso._id)
    );

    const body = {
      estado_relampago: {
        descuento,
        fecha_inicio: pickerOfertaFechaInicio,
        fecha_fin: pickerOfertaFechaFin,
      },
      cursos: cursosFiltro,
    };

    await CursosHelper.actualizarCorsosOfertaMasivo(body);
    recargar();
  };

  const leerCursosOferta = () => {
    setCursosSeleccionados(instance[7].getSelectedValues());
  };

  return (
    <Fragment>
      <SideNav />
      <div className="row">
        <FormularioAgregar>
          <p className="titulo_1_admin">Cursos</p>

          <form onSubmit={subirArchivo}>
            <p>Ficha exterior</p>
            <img
              alt="imagen subida"
              width="100%"
              src={curso.imagen_externa}
            ></img>
            <div className="file-field input-field">
              <div className="btn">
                <span>File</span>
                <input
                  name="imagen_externa"
                  onChange={actualizarFoto}
                  type="file"
                  requirede
                />
              </div>
              <div className="file-path-wrapper">
                <input
                  name="imagen_externa"
                  className="file-path validate"
                  type="text"
                  placeholder="Upload one or more files"
                  requirede
                />
              </div>
            </div>
            <div className="input-field">
              <select name="area" onChange={leerOpciones} multiple requirede>
                <option value="1">Animación, Animé y Cómic</option>
                <option value="2">Audio y Voz</option>
                <option value="3">Cine y Video</option>
                <option value="4">Artes plásticas</option>
                <option value="5">Diseño</option>
                <option value="6">Emprende</option>
                <option value="7">Escritura</option>
                <option value="8">Fotografía</option>
                <option value="9">Teoría del arte</option>
                <option value="10">Marketing y la Web</option>
                <option value="11">Multimedia y Videojuegos</option>
                <option value="12">Suite de Adobe</option>
                <option value="13">Artes escénicas</option>
              </select>
              <label>Area</label>
            </div>
            <div className="input-field">
              <select
                placeholder="Modalidad"
                name="modalidad"
                onChange={leerOpciones}
                multiple
                requirede
              >
                <option value="1">Presencial</option>
                <option value="2">Híbrido</option>
                <option value="3">Videorreunión</option>
                <option value="4">Google Classroom</option>
              </select>
              <label>Modalidad</label>
            </div>
            <div className="input-field">
              <select
                placeholder="formato"
                name="formato"
                onChange={leerOpciones}
                multiple
                requirede
              >
                <option value="1">Taller</option>
                <option value="2">Curso</option>
                <option value="3">Diplomado</option>
              </select>
              <label>Formato</label>
            </div>
            <div className="input-field">
              <select
                placeholder="formato"
                name="dias"
                onChange={leerOpciones}
                multiple
                requirede
              >
                <option value="0">Lunes</option>
                <option value="1">Martes</option>
                <option value="2">Miércoles</option>
                <option value="3">Jueves</option>
                <option value="4">Viernes</option>
                <option value="5">Sábado</option>
                <option value="6">On demand</option>
              </select>
              <label>Días</label>
            </div>
            <div className="input-field">
              <select name="nivel" onChange={leerDato} requirede>
                <option value="0" disabled selected>
                  Selecciona una opcion
                </option>
                <option value="1">Iniciación</option>
                <option value="2">Requiere conocimientos previos</option>
                {/* <option value="1">Básico</option>
                                <option value="2">Intermedio</option>
                                <option value="3">Avanzado</option>
                                <option value="4">Básico / Intermedio</option> */}
              </select>
              <label>Nivel del Curso</label>
            </div>
            <div className="input-field">
              <input
                onChange={leerDato}
                id="nombre"
                name="nombre"
                type="text"
                className="validate"
                requirede
              />
              <label for="nombre">Nombre del curso</label>
            </div>

            <p>Descripcion Externa</p>
            <p>Caracteres: {caracteres}</p>
            <div id="descripcion_externa_nuevo"></div>

            <p>Ficha interna</p>
            <p>Imagen Principal</p>
            <img
              alt="imagen subida"
              width="100%"
              src={curso.imagen_interna}
            ></img>
            <div className="file-field input-field">
              <div className="btn">
                <span>File</span>
                <input
                  name="imagen_interna"
                  onChange={actualizarFoto}
                  type="file"
                  requirede
                />
              </div>
              <div className="file-path-wrapper">
                <input
                  name="imagen_interna"
                  className="file-path validate"
                  type="text"
                  placeholder="Upload one or more files"
                  requirede
                />
              </div>
            </div>

            <div id="seccion_interna_nuevo"></div>

            <div className="input-field">
              <input
                onChange={leerDato}
                id="requisitos"
                name="requisitos"
                type="text"
                className="validate"
                requirede
              />
              <label for="requisitos">Requisitos del curso</label>
            </div>

            <div className="input-field">
              <select name="forma_pago" onChange={leerDato} requirede>
                <option value="0" disabled selected>
                  Selecciona una opcion
                </option>
                <option value="1">3 mensualidades</option>
                <option value="2">Pago de contado</option>
                <option value="3">Precio con descuento</option>
              </select>
              <label>Formas de pago</label>
            </div>

            <div>
              {curso.forma_pago === "1" && (
                <div>
                  <div className="input-field">
                    <input
                      onChange={leerPago}
                      id="costo_total"
                      name="costo_total"
                      type="text"
                      className="validate"
                      requirede
                    />
                    <label for="costo_total">Costo Total</label>
                  </div>
                  <div className="input-field">
                    <input
                      onChange={leerPago}
                      id="costo_mensual"
                      name="costo_mensual"
                      type="text"
                      className="validate"
                      requirede
                    />
                    <label for="costo_mensual">Mensualidades</label>
                  </div>
                  <div className="input-field">
                    <input
                      onChange={leerPago}
                      id="costo_contado"
                      name="costo_contado"
                      type="text"
                      className="validate"
                      requirede
                    />
                    <label for="costo_contado">Pago de contado</label>
                  </div>
                </div>
              )}
              {curso.forma_pago === "2" && (
                <div>
                  <div className="input-field">
                    <input
                      onChange={leerPago}
                      id="costo_total"
                      name="costo_total"
                      type="text"
                      className="validate"
                      requirede
                    />
                    <label for="costo_total">Costo Total</label>
                  </div>
                </div>
              )}
              {curso.forma_pago === "3" && (
                <div>
                  <div className="input-field">
                    <input
                      onChange={leerPago}
                      id="costo_total"
                      name="costo_total"
                      type="text"
                      className="validate"
                      requirede
                    />
                    <label for="costo_total">Costo Total</label>
                  </div>
                  <div className="input-field">
                    <input
                      onChange={leerPago}
                      id="costo_sabatino"
                      name="costo_sabatino"
                      type="text"
                      className="validate"
                      requirede
                    />
                    <label for="costo_sabatino">Costo Sabatino</label>
                  </div>
                </div>
              )}
            </div>

            {!flag ? (
              <p>Cargando etiquetas...</p>
            ) : (
              <div className="input-field">
                <select name="etiquetas" onChange={leerOpciones} multiple>
                  {etiquetas.map((etiqueta) => (
                    <option value={etiqueta._id}>{etiqueta.nombre}</option>
                  ))}
                </select>
                <label>Etiquetas</label>
              </div>
            )}

            {!flagFechas ? (
              <div>
                <Loader />
              </div>
            ) : (
              <div>
                <div>
                  <p>Próximas fechas</p>
                  <div
                    className="boton_agregar_formulario"
                    onClick={agregarFecha}
                  >
                    <img src={icon1} alt="" style={{ width: "23px" }} />
                  </div>
                </div>
                {fechas.map((fecha, index) => (
                  <div>
                    <div>
                      <p style={{ fontWeight: "bold" }}>Fecha {index + 1}</p>
                      <div
                        onClick={(e) => {
                          eliminarFecha(e, index);
                        }}
                        style={{
                          width: "25px",
                          height: "25px",
                          cursor: "pointer",
                        }}
                      >
                        <img src={icon63} alt="" style={{ width: "100%" }} />
                      </div>
                    </div>
                    <div className="input-field">
                      <input
                        onChange={(e) => {
                          leerFecha(e, index);
                        }}
                        id={"dias_" + index}
                        name="dias"
                        type="text"
                        className="validate"
                        requirede
                      />
                      <label
                        className={fechas[index].dias != "" && "active"}
                        for={"dias_" + index}
                      >
                        Días
                      </label>
                    </div>
                    <div className="input-field">
                      <input
                        onChange={(e) => {
                          leerFecha(e, index);
                        }}
                        id={"horario_" + index}
                        name="horario"
                        type="text"
                        className="validate"
                        requirede
                      />
                      <label
                        className={fechas[index].dias != "" && "active"}
                        for={"horario_" + index}
                      >
                        Horario
                      </label>
                    </div>
                    <div>
                      <p>Fecha: {}</p>
                      <input
                        type="text"
                        placeholder="Inicio"
                        name="fecha_inicio"
                        id={"fecha_" + index}
                        className="datepicker"
                        requirede
                      />
                      <input
                        type="text"
                        placeholder="Fin"
                        name="fecha_fin"
                        id={"fecha_" + index}
                        className="datepicker"
                        requirede
                      />
                    </div>
                    <div className="input-field">
                      <input
                        onChange={(e) => {
                          leerFecha(e, index);
                        }}
                        id={"sesiones_" + index}
                        name="sesiones"
                        type="text"
                        className="validate"
                        requirede
                      />
                      <label
                        className={fechas[index].dias != "" && "active"}
                        for={"sesiones_" + index}
                      >
                        Numero de sesiones
                      </label>
                    </div>
                    <div className="input-field">
                      <input
                        onChange={(e) => {
                          leerFecha(e, index);
                        }}
                        id={"duracion_" + index}
                        name="duracion"
                        type="text"
                        className="validate"
                        requirede
                      />
                      <label
                        className={fechas[index].dias != "" && "active"}
                        for={"duracion_" + index}
                      >
                        Total de horas
                      </label>
                    </div>
                    {!flag ? (
                      <p>Cargando profesores...</p>
                    ) : (
                      <div className="input-field">
                        <select
                          name="tutor"
                          id={"tutor_" + index}
                          onChange={(e) => {
                            leerFecha(e, index);
                          }}
                          requirede
                        >
                          <option value="0">Selecciona un profesor</option>
                          {profesoresCursos.map((profesor) => (
                            <option value={profesor._id}>
                              {profesor.nombre}
                            </option>
                          ))}
                        </select>
                        <label>Profesores</label>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            <p>Carrusel de 6 imagenes</p>
            <div
              style={{
                position: "relative",
                overflow: "auto",
                display: "flex",
              }}
            >
              {curso.carrusel_imagenes.map((imagen) => (
                <img
                  alt="imagen subida"
                  style={{ width: "100%", height: "100%" }}
                  src={imagen}
                ></img>
              ))}
            </div>
            <div className="file-field input-field">
              <div className="btn">
                <span>File</span>
                <input
                  name="carrusel_imagenes"
                  onChange={actualizarCarrusel}
                  type="file"
                  multiple
                />
              </div>
              <div className="file-path-wrapper">
                <input
                  name="carrusel_imagenes"
                  className="file-path validate"
                  type="text"
                  placeholder="Upload one or more files"
                />
              </div>
            </div>

            <p>Imagen Individual</p>
            <img
              alt="imagen subida"
              width="100%"
              src={curso.imagen_indvidual}
            ></img>
            <div className="file-field input-field">
              <div className="btn">
                <span>File</span>
                <input
                  name="imagen_indvidual"
                  onChange={actualizarFoto}
                  type="file"
                />
              </div>
              <div className="file-path-wrapper">
                <input
                  name="imagen_indvidual"
                  className="file-path validate"
                  type="text"
                  placeholder="Upload one or more files"
                />
              </div>
            </div>

            <p>YouTube</p>
            <iframe
              style={{ width: "100%", height: "auto" }}
              src={curso.url_youtube}
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
            <div className="input-field">
              <input
                onChange={leerYoutube}
                id="url_youtube"
                name="url_youtube"
                type="text"
                className="validate"
              />
              <label for="url_youtube">URL Youtube</label>
            </div>

            <p>Gratis para alumnos activos</p>
            <div>
              <p>
                <label>
                  <input
                    name="gratis"
                    type="radio"
                    onChange={() => {
                      setCurso({ ...curso, gratis: true });
                    }}
                  />
                  <span>Si</span>
                </label>
              </p>
              <p>
                <label>
                  <input
                    name="gratis"
                    type="radio"
                    onChange={() => {
                      setCurso({ ...curso, gratis: false });
                    }}
                  />
                  <span>No</span>
                </label>
              </p>
            </div>

            <div className="botonn_1_admin" style={{ marginTop: "10px" }}>
              <button type="submit">Agregar curso</button>
            </div>
          </form>
        </FormularioAgregar>
        <FormularioEditar>
          <p className="titulo_1_admin">Oferta Relampago</p>
          <form onSubmit={actualizarOfertaRelampago}>
            <div class="input-field">
              <select
                name="cursos_oferta"
                onChange={leerCursosOferta}
                multiple
                required
              >
                <option value="" disabled selected>
                  Escoje los cursos
                </option>
                {cursos.map((curso) => (
                  <option value={curso._id}>{curso.nombre}</option>
                ))}
              </select>
              <label>Cursos</label>
            </div>

            <div className="input-field">
              <input
                onChange={(e) => setDescuento(e.target.value)}
                id="descuento_relampago"
                name="descuento_relampago"
                type="text"
                className="validate"
                required
              />
              <label for="descuento_relampago">Descuento</label>
            </div>
            <p>Comienzo</p>
            <div className="input-field">
              <input
                id="fecha_inicio"
                name="fecha_inicio"
                type="text"
                className="datepicker"
                required
              />
              <label for="fecha_inicio">Fecha</label>
            </div>
            <p>Fin</p>
            <div className="input-field">
              <input
                id="fecha_fin"
                name="fecha_fin"
                type="text"
                className="datepicker"
                required
              />
              <label for="fecha_fin">Fecha</label>
            </div>

            <div className="botonn_1_admin" style={{ marginTop: "10px" }}>
              <button type="submit">Actualizar Oferta Relampago</button>
            </div>
          </form>
        </FormularioEditar>
        <View />
      </div>
    </Fragment>
  );
};

export default General;
